import api from '../utils/api';
import { cloudinaryService } from './cloudinaryService';
import { apiCache } from '../utils/cache';

export const curationService = {
  getAllPackages: async (useCache = true) => {
    const cacheKey = 'packages-all';
    
    // Check cache first
    if (useCache) {
      const cached = apiCache.get(cacheKey);
      if (cached) {
        console.log('📦 Using cached packages data');
        return cached;
      }
    }
    
    // Fetch from API
    const response = await api.get('/api/admin/curation-packages');
    const data = response.data;
    
    // Cache the response for 3 minutes
    apiCache.set(cacheKey, data, 3 * 60 * 1000);
    
    return data;
  },
  
  createPackage: async (packageData) => {
    const response = await api.post('/api/admin/curation-packages', packageData);
    // Invalidate cache
    apiCache.invalidate('packages-all');
    return response.data;
  },
  
  updatePackage: async (packageId, packageData) => {
    const response = await api.put(`/api/admin/curation-packages/${packageId}`, packageData);
    // Invalidate cache
    apiCache.invalidate('packages-all');
    return response.data;
  },
  
  deletePackage: async (packageId) => {
    const response = await api.delete(`/api/admin/curation-packages/${packageId}`);
    // Invalidate cache
    apiCache.invalidate('packages-all');
    return response.data;
  },

  // Use the new cloudinary service for image deletion
  deleteImage: async (imageUrl) => {
    return await cloudinaryService.deleteImage(imageUrl);
  },

  // New method for deleting all package images
  deletePackageImages: async (packageData) => {
    return await cloudinaryService.deletePackageImages(packageData);
  },

  getFAQs: async () => {
    const response = await api.get('/api/admin/package-faqs');
    return response.data;
  },

  updateFAQs: async (faqData) => {
    const response = await api.put('/api/admin/package-faqs', faqData);
    return response.data;
  },

  uploadPackageBrochure: async (file) => {
    return cloudinaryService.uploadFile(file, 'brochure');
  },

  updatePackageSequences: async (sequences) => {
    const response = await api.put('/api/admin/curation-packages/update-sequences', sequences);
    // Invalidate cache after updating sequences
    apiCache.invalidate('packages-all');
    return response.data;
  }
};